





























































import Vue from "vue";
import Component from "vue-class-component";
import { CrudService } from "../core/services/crudService";
import { Settings } from "../core/services/configService";
import { DateHelper } from "../core/helpers/dateHelper";
import { ProgramPackTexts } from "./programPackTexts";
import ProgramPage from "../components/programs/ProgramPage.vue";
import ProgramHero from "../components/programs/ProgramHero.vue";
import ProgramPanel from "../components/programs/ProgramPanel.vue";
import ProgramColumns from "../components/programs/ProgramColumns.vue";
import DateStripPicker from "../components/date/DateStripPicker.vue";
import CzButton from "../components/cz/CzButton.vue";
import CzChoice from "../components/cz/CzChoice.vue";
import CzNotice from "../components/cz/CzNotice.vue";
import { ShopService } from "../core/services/shopService";

@Component({
  components: { ProgramPage, ProgramHero, ProgramPanel, ProgramColumns, DateStripPicker, CzButton, CzChoice, CzNotice },
})
export default class ProgramPackBookPage extends Vue {
  program: any = null;
  loaded: boolean = false;
  texts = ProgramPackTexts;
  today: Date = new Date();
  date: string = "";
  optionals: number[] = [];
  minutes: any = {};
  result: any = null;
  start: number = 0;
  searching: boolean = false;
  searchId: number = 0;
  booking: boolean = false;
  installments: boolean = false;
  errorMsg: string = "";

  // By days, a day with no start offered shows the warning instead of the payment.
  get noRoom(): boolean {
    return this.byDays && !!this.result && !this.result.starts.length;
  }

  get installmentsLabel(): string {
    const n = this.program.installmentCount;
    const label = this.$t("{0} installments").toString().replace("{0}", n);
    return this.result ? `${label} · ${this.texts.money(Math.floor((this.result.price * 100) / n) / 100)}` : label;
  }

  get byDays(): boolean {
    return this.program.layout === 0;
  }

  get emptyText(): string {
    return this.loaded && this.program === null ? this.$t("This program is not available").toString() : "";
  }

  get upgrades(): any[] {
    return ProgramPackTexts.cards(this.program, 0, true).concat(ProgramPackTexts.cards(this.program, 1, true));
  }

  get choices(): any[] {
    return ProgramPackTexts.cards(this.program, 0)
      .concat(this.upgrades.filter((k: any) => k.cardType === 0 && this.optionals.indexOf(k.id) >= 0))
      .filter((k: any) => k.otherMinutes && k.otherMinutes.length);
  }

  // One column per day of the chosen start, each appointment with its time.
  get itinerary(): any[] {
    const s = this.result && this.result.starts[this.start];
    if (!s) return [];
    const days: any = {};
    s.items.forEach((i: any) => {
      const day = i.start.substring(0, 10);
      (days[day] = days[day] || []).push({ name: i.name, detail: `${this.time(i.start)} - ${this.time(i.end)}` });
    });
    return Object.keys(days).map((d) => ({ name: ProgramPackTexts.date(d, false), when: "", rows: days[d] }));
  }

  t(key: string): string {
    return this.$t(key).toString();
  }

  time(input: string): string {
    return input.substring(11, 16);
  }

  chosen(k: any): number {
    return this.minutes[k.id] || k.minutes;
  }

  choose(k: any, m: number) {
    this.$set(this.minutes, k.id, m);
    this.search();
  }

  toggle(id: number) {
    const i = this.optionals.indexOf(id);
    if (i >= 0) this.optionals.splice(i, 1);
    else this.optionals.push(id);
    this.search();
  }

  dateChanged(ev: any) {
    this.date = ev.systemStrDate;
    this.search();
  }

  async search() {
    if (!this.date) return;
    const id = ++this.searchId;
    this.searching = true;
    const data = await new CrudService().httpPost(`${Settings.HostName}/api/publicprogrampacks/${this.$route.params.id}/search`, {
      date: this.date,
      minutes: this.minutes,
      optionals: this.optionals,
    });
    if (id !== this.searchId) return;
    this.result = data && data.ok ? data.model : null;
    this.start = 0;
    this.searching = false;
  }

  // The itinerary shown is pre-booked (by phases nothing is) and the program's sale goes to the cart, like a booking does.
  async book() {
    const s = this.result && this.result.starts[this.start];
    if ((this.byDays && !s) || this.booking) return;
    if (this.$store.state.loggedIn === false) {
      this.$store.commit("openLogin", { backUrl: this.$route.fullPath });
      return;
    }
    this.booking = true;
    this.errorMsg = "";
    const res = await new CrudService().httpPost(`${Settings.HostName}/api/publicprogrampacks/${this.$route.params.id}/book`, {
      start: s ? s.start : this.date,
      minutes: this.minutes,
      optionals: this.optionals,
      installmentCount: this.installments ? this.program.installmentCount : null,
    });
    this.booking = false;
    if (!res || !res.ok) {
      this.errorMsg = res && res.errorMsg ? res.errorMsg : this.$t("Crash").toString();
      if (!res || !res.model || !res.model.serviceFree) this.search();
      return;
    }
    if (res.model.serviceFree) {
      this.$router.push({ path: "/my-plan", query: { program: String(res.model.enrollmentId) } });
      return;
    }
    const sale = res.model;
    sale.title = sale.description;
    new ShopService().addSaleToCart(sale, null);
    this.$router.push("/checkout");
  }

  async mounted() {
    const data = await new CrudService().httpGet(`${Settings.HostName}/api/publicprogrampacks/${this.$route.params.id}`);
    this.program = data && data.ok ? data.model : null;
    this.loaded = true;
    if (this.program) {
      this.dateChanged({ systemStrDate: DateHelper.toSystemString(this.today) });
    }
  }
}
